import { isSubfieldEnabled, isSubfieldRequired, isAutocompleteMandatoryUnmet } from '../../Admin/FormBuilder/utils/addressGroupFields';
import { isTextListAnswerEmpty } from '../../Admin/FormBuilder/utils/textListItems';
import { isConsentAnswerEmpty } from '../../Admin/FormBuilder/utils/consentItems';

export const isValueEmpty = (field, value) => {
    switch (field.type) {
        case 'checkbox':
            return !Array.isArray(value) || value.length === 0;
        case 'multiselect':
            return !Array.isArray(value) || value.length === 0;
        case 'signature':
            return !value;
        case 'consent':
            return isConsentAnswerEmpty(field, value);
        case 'file':
            return !value;
        case 'address-group':
            return Object.entries(field.fields ?? {}).some(
                ([key, subfield]) =>
                    isSubfieldEnabled(subfield) &&
                    isSubfieldRequired(subfield, field, key) &&
                    !String(value?.[key] ?? '').trim()
            );
        case 'text-list':
            // Untouched (still on its prefill defaults) isn't necessarily
            // empty — fall back to the field's own prefill items.
            return isTextListAnswerEmpty(value ?? field.items ?? []);
        default:
            return value === undefined || value === null || String(value).trim() === '';
    }
};

// Pulled out so it can validate just a single page's fields (the per-page
// "Next" gate) as well as the whole form (defense-in-depth right before the
// real submit, on the last page) — both call this the same way, just with a
// different `fieldsToValidate` slice.
export const validateFields = (fieldsToValidate, formData) => {
    const nextErrors = {};

    fieldsToValidate.forEach((field) => {
        // address-group and consent's required-ness now live per-subfield
        // /per-item (see isValueEmpty) rather than on the field's own
        // top-level toggle, so their checks must always run regardless of
        // field.required.
        if (!['address-group', 'consent'].includes(field.type) && !field.required) return;
        if (['richtext', 'image', 'button', 'page-break'].includes(field.type)) return;
        if (isValueEmpty(field, formData[field.id])) {
            nextErrors[field.id] = `${field.label || 'This field'} is required`;
            return;
        }
        if (field.type === 'address-group' && isAutocompleteMandatoryUnmet(field, formData[field.id])) {
            nextErrors[field.id] = 'Please select an address from the suggestions.';
        }
    });

    return nextErrors;
};
